import { render, staticRenderFns } from "./ProfileCompleteModal.vue?vue&type=template&id=64fac394&"
import script from "./ProfileCompleteModal.vue?vue&type=script&lang=js&"
export * from "./ProfileCompleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports